module.exports = function (fox) {
	'use strict';

	var RuleBase = require('../rule')(fox);

	return fox.extend({
		execute: function () {
			if (!this.getParams('enabled')) {
				this.addRouteHook();
			}
		},

		onRoute: function (route) {
			if (route.path === 'liveshow' && !this.getParams('enabled')) {
				route.action = '#home #404';
				route.path = '404';
			}

			return true;
		}
	}, RuleBase, null, 'Rule_Liveshow');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/liveshow.js
// module id = 66
// module chunks = 4